import { IFormSectionService } from "../../service/formconfiguration/FormSectionService";

export default class InvalidateFormSectionInteractor {
  private formSectionService: IFormSectionService;

  constructor(formSectionService) {
    this.formSectionService = formSectionService;
  }

  async execute(formTypeCode: string, formSectionId: number) {
    return this.formSectionService.invalidateFormSection(
      formTypeCode,
      formSectionId
    );
  }
}
